import React from 'react';
import { motion } from 'framer-motion';

const DontBeBoxed = () => {
  const scrollToPlans = () => {
    const el = document.getElementById('plans');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="py-24 md:py-36 bg-white">
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.0, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-[42px] md:text-[72px] lg:text-[88px] leading-[1.0] tracking-tight font-semibold text-neutral-900"
        >
          Master the Specification.
        </motion.h2>

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.0, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="mt-3 md:mt-5 font-display text-[42px] md:text-[72px] lg:text-[88px] leading-[1.0] tracking-tight font-semibold text-neutral-900"
        >
          Secure the Grade.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="mt-8 md:mt-10 text-[14px] md:text-[16px] text-neutral-500"
        >
          You&apos;re closer than you think.
        </motion.p>

        <motion.button
          onClick={scrollToPlans}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.55 }}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          className="pill-btn mt-8 bg-neutral-900 text-white px-8 py-3.5 text-[14px] font-medium"
        >
          View plans
        </motion.button>
      </div>
    </section>
  );
};

export default DontBeBoxed;
